const DEFAULT_PIN_W = 300;
const DEFAULT_PIN_H = 400;
export const DONE_GAP_FRAME_PADDING = 32;

/**
 * Grow a single frame to cover member pin rects. Does not move the pins.
 */
export function fitFrameToMemberPlacements(frame, placements = [], padding = DONE_GAP_FRAME_PADDING) {
  const next = frame && typeof frame === 'object' ? { ...frame } : {};
  let minX = Number.isFinite(Number(next.x)) ? Number(next.x) : Infinity;
  let minY = Number.isFinite(Number(next.y)) ? Number(next.y) : Infinity;
  let maxX = Number.isFinite(Number(next.x)) && Number.isFinite(Number(next.w))
    ? Number(next.x) + Number(next.w)
    : -Infinity;
  let maxY = Number.isFinite(Number(next.y)) && Number.isFinite(Number(next.h))
    ? Number(next.y) + Number(next.h)
    : -Infinity;

  for (const placement of placements) {
    const x = Number(placement?.x);
    const y = Number(placement?.y);
    const w = Number(placement?.width) || DEFAULT_PIN_W;
    const h = Number(placement?.height) || DEFAULT_PIN_H;
    if (!Number.isFinite(x) || !Number.isFinite(y)) continue;
    minX = Math.min(minX, x - padding);
    minY = Math.min(minY, y - padding);
    maxX = Math.max(maxX, x + w + padding);
    maxY = Math.max(maxY, y + h + padding);
  }
  if (!Number.isFinite(minX) || !Number.isFinite(maxX)) return next;
  return {
    ...next,
    x: minX,
    y: minY,
    w: Math.max(maxX - minX, Number(next.w) || 0),
    h: Math.max(maxY - minY, Number(next.h) || 0),
  };
}
